export type EmailStarTag = {
  id: string
  name: string
  color: string
  sortOrder: number
}

export const sortStarTags = (tags: EmailStarTag[]): EmailStarTag[] =>
  [...tags].sort((a, b) => {
    if (a.sortOrder !== b.sortOrder) return a.sortOrder - b.sortOrder
    return a.name.localeCompare(b.name)
  })

/** Gmail-style cycle: none → first tag → … → last tag → none. */
export const getNextStarTagId = (
  currentTagId: string | null | undefined,
  tags: EmailStarTag[],
): string | null => {
  const sorted = sortStarTags(tags)
  if (!sorted.length) return null
  if (!currentTagId) return sorted[0].id
  const index = sorted.findIndex((tag) => tag.id === currentTagId)
  if (index === -1) return sorted[0].id
  if (index >= sorted.length - 1) return null
  return sorted[index + 1].id
}

export const findStarTagById = (
  tags: EmailStarTag[],
  tagId: string | null | undefined,
): EmailStarTag | null =>
  tagId ? (tags.find((tag) => tag.id === tagId) ?? null) : null
